import { useSyncExternalStore } from 'react';
import { parseCartKey } from '../../miniapp/utils/weight';

const STORAGE_KEY = 'tea-web-cart';
export const EMPTY_CART: Readonly<Record<string, number>> = Object.freeze({});
const listeners = new Set<() => void>();
let cachedRaw: string | null | undefined;
let cachedCart: Readonly<Record<string, number>> = EMPTY_CART;

function parse(raw: string | null): Readonly<Record<string, number>> {
  if (raw === cachedRaw) return cachedCart;
  cachedRaw = raw;
  if (!raw) return (cachedCart = EMPTY_CART);
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const valid: Record<string, number> = {};
    for (const [key, value] of Object.entries(parsed)) {
      if (parseCartKey(key) && Number.isInteger(value) && Number(value) > 0)
        valid[key] = Number(value);
    }
    cachedCart = Object.freeze(valid);
  } catch {
    cachedCart = EMPTY_CART;
  }
  return cachedCart;
}

function getSnapshot(): Readonly<Record<string, number>> {
  if (typeof window === 'undefined') return EMPTY_CART;
  try {
    return parse(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return EMPTY_CART;
  }
}
function getServerSnapshot(): Readonly<Record<string, number>> {
  return EMPTY_CART;
}
function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  if (typeof window !== 'undefined') window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(listener);
    if (!listeners.size && typeof window !== 'undefined')
      window.removeEventListener('storage', onStorage);
  };
}
function onStorage(event: StorageEvent): void {
  if (event.key === STORAGE_KEY || event.key === null) notify();
}
function notify(): void {
  for (const listener of listeners) listener();
}
export function writeCart(cart: Record<string, number>): void {
  const serialized = JSON.stringify(cart);
  try {
    window.localStorage.setItem(STORAGE_KEY, serialized);
  } catch {
    /* storage can be unavailable */
  }
  parse(serialized);
  notify();
}
export function useCartStore(): Readonly<Record<string, number>> {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
